"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleStore = void 0;
var app_1 = require("services/page/app");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var website_1 = require("utils/website");
var id = 0;
var ModuleStore = (function () {
    function ModuleStore() {
        var _this = this;
        this.maxRequestCount = 3;
        this.requestCount = 0;
        this.moduleMap = {};
        this.waitingRequestFunc = [];
        this.loadModuleDetailById = function (moduleId) {
            if (!moduleId) {
                return Promise.resolve(null);
            }
            if (_this.moduleMap[moduleId]) {
                return Promise.resolve(_this.moduleMap[moduleId]);
            }
            _this.requestCount++;
            return app_1.GetFrontModules({
                moduleId: [moduleId],
                meta: {
                    catalog: isomorphismConstant_1.default.country,
                    lang: isomorphismConstant_1.default.language,
                    client: website_1.isPC() ? "web" : "mweb",
                    priceSymbol: isomorphismConstant_1.default.currency
                }
            })
                .then(function (_a) {
                var _b;
                var mods = _a.mods;
                var moduleDetail = mods[moduleId];
                _this.moduleMap = __assign(__assign({}, _this.moduleMap), (_b = {}, _b[moduleId] = moduleDetail, _b));
                _this.requestCount--;
                return moduleDetail;
            }, function (err) {
                console.error(err);
                _this.requestCount--;
                return null;
            })
                .then(function (result) {
                if (_this.requestCount < _this.maxRequestCount && _this.waitingRequestFunc.length > 0) {
                    _this.waitingRequestFunc[0].func();
                }
                return result;
            });
        };
        this.addToQueue = function (resolve, moduleId) {
            var currentId = id++;
            _this.waitingRequestFunc = __spreadArrays(_this.waitingRequestFunc, [
                {
                    id: currentId,
                    func: function () {
                        _this.waitingRequestFunc = _this.waitingRequestFunc.filter(function (v) { return v.id !== currentId; });
                        _this.loadModuleDetailById(moduleId).then(function (moduleDetail) {
                            resolve(moduleDetail);
                        });
                    }
                }
            ]);
        };
        this.loadModuleDetailQueue = function (moduleId) {
            return new Promise(function (resolve) {
                if (_this.requestCount >= _this.maxRequestCount) {
                    _this.addToQueue(resolve, moduleId);
                }
                else {
                    _this.loadModuleDetailById(moduleId).then(function (moduleDetail) {
                        resolve(moduleDetail);
                    });
                }
            });
        };
    }
    return ModuleStore;
}());
exports.ModuleStore = ModuleStore;
